var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwnerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "describe-logo",
    width: 24,
    height: 24,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8237 9.15142C22.8237 14.0465 18.8988 17.9715 14.0003 17.9715C9.10349 17.9715 5.17701 14.0465 5.17701 9.15142C5.17701 4.25637 9.10349 0.333008 14.0003 0.333008C18.8988 0.333008 22.8237 4.25637 22.8237 9.15142ZM14.0003 33.6663C6.77094 33.6663 0.666992 32.4913 0.666992 27.958C0.666992 23.4228 6.80929 22.2895 14.0003 22.2895C21.2313 22.2895 27.3337 23.4645 27.3337 27.998C27.3337 32.533 21.1913 33.6663 14.0003 33.6663Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerLogo);
export default __webpack_public_path__ + "static/media/owner-logo.638ddc46195827e671ee9b008544ca07.svg";
export { ForwardRef as ReactComponent };